// Copyright (c) 2025 by Audere

import { filterConversations } from "../features/data/conversationUtils";
import { LabelerConversationData, QCConversationData } from "../features/api/labelApiSlice";
import { useMemo } from "react";

export const useFilteredConversations = (
  conversations: LabelerConversationData[] | QCConversationData[],
  searchInput: string
) => {
  return useMemo(
    () => filterConversations(conversations, searchInput),
    [conversations, searchInput]
  );
};
